import React, { useEffect } from 'react';
import { cvcInputReact } from '../../utilities/payform';
import unpick from '../../../utilities/unpick';
import HiddenComponents from './hidden-components';
import Icon from './card-icon';
import { iconTypes } from '../../constants';
import { isObject } from '../../../utilities/utils';

const displayName = 'Card Security Code';

export default function CardSecurityCode(props) {
  const { isValid, hiddenField, hideValue, showCardIcon, cardType, className, icons, innerRef } = props;
  const p = unpick(props, [
    'showCardIcon',
    'cardType',
    'ariaLabel',
    'isValid',
    'hiddenField',
    'hideValue',
    'icons',
    'innerRef',
  ]);
  let inputType = 'tel';

  if (hideValue) {
    inputType = 'password';
    p.autoComplete = 'off';
    p.inputMode = 'numeric';
  }

  let hiddenComponents = null;

  if (!hiddenField) {
    hiddenComponents = {
      CardExpirationDate: {
        autoComplete: 'cc-exp',
      },
      CreditCardNumber: {
        autoComplete: 'cc-number',
      },
      CardHolderName: {
        autoComplete: 'cc-name',
      },
    };
  }

  return (
    <>
      <input
        type={inputType}
        {...p}
        {...cvcInputReact(props)}
        aria-label={props.ariaLabel || displayName}
        aria-placeholder={props.placeholder || ''}
        aria-invalid={!isValid}
        className={showCardIcon ? `card-security-code ${className}` : className}
        ref={innerRef}
      />
      {showCardIcon && (
        <Icon
          icons={icons}
          styles={isObject(showCardIcon) && showCardIcon}
          type={iconTypes.cardSecurityCode}
          card={cardType}
        />
      )}
      {!hiddenField && <HiddenComponents hiddenComponents={hiddenComponents} />}
    </>
  );
}

CardSecurityCode.displayName = 'CardSecurityCode';
